import React from "react";
import type { ToolCallData } from "../../adapters/chatAdapter";
import { ToolCardFallback } from "./tool-cards/ToolCardFallback";
import { SearchCard } from "./tool-cards/SearchCard";
import { ChapterCard } from "./tool-cards/ChapterCard";
import { SettingCard } from "./tool-cards/SettingCard";
import { TaskCard } from "./tool-cards/TaskCard";
import { InteractionCard } from "./tool-cards/InteractionCard";
import { SubagentCard } from "./tool-cards/SubagentCard";
import { ExternalCard } from "./tool-cards/ExternalCard";
import { UtilityCard } from "./tool-cards/UtilityCard";

export interface ToolCardComponentProps {
  toolCall: ToolCallData;
  onAskUserAnswer?: (questionIndex: number, optionIndices: number[], customText?: string) => void;
}

type ToolCardComponent = React.FC<ToolCardComponentProps>;

const TOOL_CARD_MAP: Record<string, ToolCardComponent> = {
  search: SearchCard,
  neo4j: SearchCard,
  chapter_read: ChapterCard,
  chapter_list: ChapterCard,
  chapter_write: ChapterCard,
  chapter_update: ChapterCard,
  title_rename: ChapterCard,
  setting_read: SettingCard,
  setting_list: SettingCard,
  setting_write: SettingCard,
  setting_update: SettingCard,
  todo_write: TaskCard,
  todo_read: TaskCard,
  ask_user: InteractionCard,
  subagent_call: SubagentCard,
  websearch: ExternalCard,
  web_fetch: ExternalCard,
  memory_write: UtilityCard,
  get_tool: UtilityCard,
  get_skill: UtilityCard,
};

export const ToolCardRenderer: React.FC<ToolCardComponentProps> = ({
  toolCall,
  onAskUserAnswer,
}) => {
  const CardComponent = TOOL_CARD_MAP[toolCall.toolName] || ToolCardFallback;
  return <CardComponent toolCall={toolCall} onAskUserAnswer={onAskUserAnswer} />;
};

export { TOOL_CARD_MAP };
export type { ToolCardComponent };
